const MAX_PREMIUM_TOLERANCE = 0.02;
const MIN_PREMIUM_TOLERANCE = -0.02;

export const canToleratePremium = (grossPremium: number) => {
  if (grossPremium === 0) {
    return true
  } else {
    return grossPremium >= MIN_PREMIUM_TOLERANCE && grossPremium <= MAX_PREMIUM_TOLERANCE
  }
}
